import { Suspense } from 'react';

import { ErrorBoundary } from '@packages/shared/src/ui/ErrorBoundary/ErrorBoundary';

import { CategoryPageBackChannelRequestDebugInfo } from './CategoryPageBackChannelRequestDebugInfo';
import { SearchResultPageBackChannelRequestDebugInfo } from './SearchResultPageBackChannelRequestDebugInfo';

export const BackChannelRequestDebugInfo = ({
  variables,
}: {
  variables: { query: string } | { pathname: string };
}) => (
  <ErrorBoundary fallback={<h1>Error, please try again</h1>}>
    <Suspense fallback={<h1>Loading...</h1>}>
      {'pathname' in variables && <CategoryPageBackChannelRequestDebugInfo variables={variables} />}
      {'query' in variables && (
        <SearchResultPageBackChannelRequestDebugInfo variables={variables} />
      )}
    </Suspense>
  </ErrorBoundary>
);
